import { useContext } from 'react';
import { BalanceContext } from 'contexts/balanceContext/BalanceContext';

export const useBalanceContext = () => {
	return useContext(BalanceContext);
};
